import { InjectionToken } from '@angular/core';

export interface IStorageService {
	getValue: (key: string) => any;
	setValue: (key: string, value: any) => void;
	clearValue: (key: string) => void;
}

export const storageServiceToken = new InjectionToken<IStorageService>('IStorageService');
